import { Validate } from 'class-validator';
import * as uuid from 'uuid';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { QuotePaxValidator } from 'src/core/customValidator/quote-pax-validator';

export class QuotePaxDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.QuotePaxItem, Model.Bookings.Logic.ViewModels.QuotePaxItem, QuotePaxItem> {
	public map(entity: Model.Bookings.Logic.ViewModels.QuotePaxItem): QuotePaxItem {
		return new QuotePaxItemModel(entity);
	}

	static make(ctx?: any, saveAsDelete: boolean = false): QuotePaxDataService {
		return new QuotePaxDataService(ctx, ctx => ctx.QuotePaxs, saveAsDelete);
	}

	add(quote: QuoteItem, order: number, client: ClientItem, dynamicProperties?: any) {
		const entity = new Model.Bookings.Logic.ViewModels.QuotePaxItem();
		entity.order = order;
		if (quote.id > 0) {
			entity.quoteId = quote.id;
		}
		entity.clientId = null;
		entity.clientDisplayName = null;
		const date = new Date();
		if (dynamicProperties)
			(<any>entity).dynamicProperties = dynamicProperties;
		else
			(<any>entity).dynamicProperties = {
				salutation: '',
				foreName: '',
				middleName: '',
				surName: '',
				birthDate: new Date(date.getUTCFullYear() - 30, date.getUTCMonth()),
				gender: 'Male',
				billingTo: null,
				notes: [],
			};
		if (client != null && client.type == 0) {
			const model = client.dynamicProperties['person'] as PersonItem;
			entity.clientId = client.id;
			entity.clientDisplayName = client.displayName;
			(<any>entity).dynamicProperties['salutation'] = model.salutation;
			(<any>entity).dynamicProperties['foreName'] = model.firstName;
			(<any>entity).dynamicProperties['middleName'] = model.middleName;
			(<any>entity).dynamicProperties['surName'] = model.lastName;
			if (model.birthDate) {
				(<any>entity).dynamicProperties['birthDate'] = model.birthDate;
			}
			(<any>entity).dynamicProperties['gender'] = model.gender;
		}
		if (quote.clientId != null) {
			(<any>entity).dynamicProperties['billingTo'] = quote.clientId;
		}
		entity.id = uuid.v4();
		return entity;
	}
}

export class QuotePaxItemModel extends EntityModel<Model.Bookings.Logic.ViewModels.QuotePaxItem, QuotePaxItem> implements QuotePaxItem {
	@property<QuotePaxItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: string;

	@property<QuotePaxItemModel>(o => o.entity.clientId, (o, value) => o.entity.clientId = value)
	public clientId?: number;

	@property<QuotePaxItemModel>(o => o.entity.quoteId, (o, value) => o.entity.quoteId = value)
	//@IsDefined({ message: 'quote is required' })
	public quoteId: number;

	@property<QuotePaxItemModel>(o => o.entity.quote, (o, value) => o.entity.quote = value)
	public quote: any;

	@property<QuotePaxItemModel>(o => o.entity.order, (o, value) => o.entity.order = value)
	public order: number;

	@property<QuotePaxItemModel>(o => o.entity.clientDisplayName, (o, value) => o.entity.clientDisplayName = value)
	public clientDisplayName?: string;

	public get formalName(): string {
		return `${this.dynamicProperties['salutation'] || ''} ${this.dynamicProperties['foreName'] || ''} ${this.dynamicProperties['middleName'] || ''} ${this.dynamicProperties['surName'] || ''}`.trim();
	}

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(QuotePaxValidator)
	public dynamicProperties: { [prop: string]: any };
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-paxs/quote-pax-form.data.ts